module.exports = __webpack_public_path__ + "img/rocket.b4878de0.png";